import moment, { Moment } from 'moment';
import { EventValue } from 'rc-picker/lib/interface';

export const [ALL, KUAIDI, TONGCHENG, ZITI] = [-1, 0, 1, 2];

export const defaultPageSize = 10;

// 订单状态映射
const orderStatusSourceMap = {};
orderStatusSourceMap[ALL] = [
  { name: '全部', id: 'all', value: -1 },
  { name: '待支付', id: 'toPaid', value: 0 },
  { name: '已完成', id: 'done', value: 3 },
  { name: '待售后', id: 'toServicing', value: 7 },
  { name: '退款成功', id: 'refunded', value: 401 },
  { name: '已取消', id: 'canceled', value: 4 },
];
orderStatusSourceMap[KUAIDI] = [
  { name: '全部', id: 'all', value: -1 },
  { name: '待支付', id: 'toPaid', value: 0 },
  { name: '待发货', id: 'toSend', value: 1 },
  { name: '待收货', id: 'toReceive', value: 2 },
  { name: '已完成', id: 'done', value: 3 },
  { name: '待退款', id: 'refund', value: 5 },
  { name: '退款中', id: 'refunding', value: 6 },
  { name: '待售后', id: 'toServicing', value: 7 },
  { name: '退款成功', id: 'refunded', value: 401 },
  { name: '已取消', id: 'canceled', value: 4 },
];
orderStatusSourceMap[TONGCHENG] = [
  { name: '全部', id: 'all', value: -1 },
  { name: '待支付', id: 'toPaid', value: 0 },
  // { name: '预约中', id: 'appointing', value: 102 },
  // { name: '待接单', id: 'toShipped', value: 1 },
  { name: '已接单', id: 'toReceipt', value: 110 },
  { name: '发货失败', id: 'deliveryFailed', value: 99 },
  { name: '配送中', id: 'sending', value: 2 },
  { name: '已完成', id: 'done', value: 3 },
  { name: '待退款', id: 'refund', value: 5 },
  { name: '退款中', id: 'refunding', value: 6 },
  { name: '待售后', id: 'toServicing', value: 7 },
  { name: '退款成功', id: 'refunded', value: 401 },
  { name: '已取消', id: 'canceled', value: 4 },
];
orderStatusSourceMap[ZITI] = [
  { name: '全部', id: 'all', value: -1 },
  { name: '待支付', id: 'toPaid', value: 0 },
  // { name: '预约中', id: 'appointing', value: 102 },
  // { name: '待接单', id: 'toShipped', value: 1 },
  { name: '已接单', id: 'toReceipt', value: 110 },
  { name: '已完成', id: 'done', value: 3 },
  { name: '待退款', id: 'refund', value: 5 },
  { name: '退款中', id: 'refunding', value: 6 },
  { name: '待售后', id: 'toServicing', value: 7 },
  { name: '退款成功', id: 'refunded', value: 401 },
  { name: '已取消', id: 'canceled', value: 4 },
];

export const orderStatusMap = orderStatusSourceMap;

const orderStatusSourceMapWithDispatchMethod = {};
orderStatusSourceMapWithDispatchMethod[KUAIDI] = {
  0: '待支付',
  1: '待发货',
  2: '待收货',
  3: '已完成',
  5: '待退款',
  6: '退款中',
  7: '待售后',
  401: '退款成功',
  4: '已取消',
};
orderStatusSourceMapWithDispatchMethod[TONGCHENG] = {
  0: '待支付',
  102: '预约中',
  // 1: '待接单',
  110: '已接单',
  99: '发货失败',
  2: '配送中',
  3: '已完成',
  5: '待退款',
  6: '退款中',
  7: '待售后',
  401: '退款成功',
  4: '已取消',
};
orderStatusSourceMapWithDispatchMethod[ZITI] = {
  0: '待支付',
  102: '预约中',
  // 1: '待接单',
  110: '已接单',
  3: '已完成',
  5: '待退款',
  6: '退款中',
  7: '待售后',
  401: '退款成功',
  4: '已取消',
};

export const historicalOrder = [
  { name: '全部', id: 'all', value: -1 },
  { name: '已完成', id: 'done', value: 3 },
  { name: '退款成功', id: 'refunded', value: 401 },
  { name: '已取消', id: 'canceled', value: 4 },
];
export const orderStatusMapWithDispatchMethod = orderStatusSourceMapWithDispatchMethod;

// RadioChange顶部tab切换
export const pathMapTopRadio = {
  threeTabs: {
    topname: '订单',
    list: [
      { value: 0, name: '快递订单' },
      { value: 1, name: '同城订单' },
      { value: 2, name: '自提订单' },
    ],
    defaultValue: 0,
  },
  twoTabs: {
    topname: '订单',
    list: [
      { value: 1, name: '同城订单' },
      { value: 2, name: '自提订单' },
    ],
    defaultValue: 1,
  },
};

export const methodOptions = {
  0: '快递',
  1: '同城',
  9: '全部',
};

export const typeOptions = [
  {
    value: -1,
    name: '全部',
  },
  {
    value: 1,
    name: '拼团单',
  },
  {
    value: 3,
    name: '分销单',
  },
  {
    value: 6,
    name: '企业单A',
  },
  {
    value: 7,
    name: '企业单B',
  },
];
export const typeOptionsMapName = {
  0: '全部',
  1: '拼团单',
  3: '分销单',
  6: '企业单A',
  7: '企业单B',
};

export const orderTime: { [key: string]: [EventValue<Moment>, EventValue<Moment>] } = {
  最近3天: [moment().add(-3, 'day').startOf('minute'), moment().startOf('minute')],
  最近7天: [moment().add(-7, 'day').startOf('minute'), moment().startOf('minute')],
  最近14天: [moment().add(-14, 'day').startOf('minute'), moment().startOf('minute')],
};

export const appointmentOrderTime: { [key: string]: [EventValue<Moment>, EventValue<Moment>] } = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近三天: [moment().startOf('day'), moment().add(3, 'day').startOf('day')],
};

export const defaultOrderTime = [moment().add(-14, 'day').startOf('day'), moment().endOf('day')];

export const isAppointmentArr = [
  {
    value: -1,
    name: '全部',
  },
  {
    value: 1,
    name: '预约',
  },
  {
    value: 0,
    name: '非预约',
  },
];

export const companyTypeList = [
  { value: -1, label: '全部' },
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
];
export const outOrderTypeList = [
  { key: '', content: '全部' },
  { key: 0, content: '丰食商城' },
  { key: 1, content: '丰享商城' },
];

export const orderChannelSource = [
  { value: -1, label: '全部' },
  { value: 0, label: '普通订单-正常单' },
  { value: 7, label: '普通订单-补单' },
  { value: 1, label: '丰声-点餐订单' },
  { value: 13, label: '丰声-加班餐' },
  { value: 2, label: '丰食-丰享订单' },
  { value: 3, label: '飞书订单' },
  { value: 4, label: 'APP订单' },
  { value: 8, label: '钉钉' },
  { value: 9, label: '企业微信' },
  { value: 10, label: '关爱通订单' },
  { value: 14, label: '支付宝企业付' },
  { value: 16, label: '魔盒订单' },
  { value: 19, label: '友宝订单' },
  { value: 20, label: '丰食-丰享(融合)' },
  { value: 41, label: '丰享公众号' },
  { value: 53, label: '丰食微服务' },
];
export const freightOrderChannelSource = [
  { value: -1, label: '全部' },
  { value: 0, label: '普通订单-正常单' },
  { value: 7, label: '普通订单-补单' },
  { value: 15, label: '顺丰APP-生鲜商城' },
  { value: 17, label: '顺丰APP-渔博会' },
  { value: 18, label: '携程订单' },
  { value: 20, label: '丰食-丰享(融合)' },
  { value: 40, label: '丰享分账订单' },
  { value: 41, label: '丰享公众号' },
  { value: 44, label: '中信订单' },
];

export const orderSourceValue = {
  0: '普通订单-正常单',
  1: '丰声-点餐订单',
  13: '丰声-加班餐',
  2: '丰食-丰享订单',
  3: '飞书订单',
  4: 'APP订单',
  8: '钉钉',
  9: '企业微信',
  5: '索迪斯订单',
  7: '普通订单-补单',
  10: '关爱通订单',
  14: '支付宝企业付',
  15: '顺丰APP-生鲜商城',
  16: '魔盒订单',
  17: '顺丰APP-渔博会',
  19: '友宝订单',
  20: '丰食-丰享(融合)',
  41: '丰享公众号',
  44: '中信订单',
  53: '丰食微服务',
};
export const defaultFilter = {
  orderId: '', // 订单号默认值
  receiverPhone: '', // 买家默认值
  dispatchMethod: 1, // 默认同城配送
  skuName: '', // 商品名称默认值
  status: -1, // 订单状态默认全部
  orderTime: [moment().add(-7, 'day').startOf('day'), moment().endOf('day')],
  orderTimeMonth: moment().subtract(1, 'months'),
  page: 1,
  pageSize: defaultPageSize,
  orderType: -1, // 订单类型，默认是全部
  orderFlag: -1,
  // isAppointment: -1, // 默认全部是否预约
  appointmentTime: [],
  companyType: -1,
  shopName: '',
  companyName: '',
  orderChannel: -1,
  orderBy: '',
  unionShopId: 0,
  cityCodes: [],
  subShopName: '',
  businessDistrictId: '',
  // deliveryFailed: undefined, // 发货失败状态,默认不传
  shopId: '',
  subShopId: '',
  companyId: '',
  businessDistrictIds: [],
  isCustomerGroup: '',
  receiverName: '',
  saasAgentId: undefined,
};

export const expressCompanyMap = {
  YZZS: '一站专送',
  SFTC: '顺丰同城',
  SJZPS: '商家自配送',
  FSZPS: '丰食配',
};
export const cabinetStatusTypeList = [
  { value: -1, label: '全部' },
  { value: 1, label: '预约中' },
  { value: 2, label: '已存餐' },
  { value: 3, label: '已取餐' },
  { value: 4, label: '已取消' },
];
